"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Header = function (_a) {
    var logo = _a.logo, children = _a.children, _b = _a.customClasses, customClasses = _b === void 0 ? '' : _b;
    return (react_1.default.createElement("header", { className: "axxes-header " + customClasses },
        react_1.default.createElement("div", { className: 'axxes-header__topbar' },
            react_1.default.createElement(react_router_dom_1.Link, { className: 'axxes-header__topbar__logo', to: '/' },
                react_1.default.createElement("img", { src: logo, alt: 'logo', onError: function (e) {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = './logo.png';
                    } })),
            children)));
};
exports.Header = Header;
